import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleRVPurchaseSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <g>
            <path
              className={css(styles.actionAccent)}
              d="M28.149,36.216a1.6,1.6,0,1,0-1.6-1.6A1.6,1.6,0,0,0,28.149,36.216ZM29.244,27.8l5.59,5.495a1.287,1.287,0,0,1,0,1.846l-5.59,5.5a1.376,1.376,0,0,1-.964.391H6.272a1.335,1.335,0,0,1-1.354-1.315V28.719a1.335,1.335,0,0,1,1.354-1.314H28.28A1.375,1.375,0,0,1,29.244,27.8ZM15.918,36.817c-.592-.159-.987-.54-.987-.927a.6.6,0,1,0-1.2,0,2.379,2.379,0,0,0,2.188,2.154v.362a.6.6,0,1,0,1.2,0v-.361a2.373,2.373,0,0,0,2.188-2.155,2.374,2.374,0,0,0-2.188-2.155V31.754c.593.158.987.538.987.928a.6.6,0,1,0,1.2,0,2.373,2.373,0,0,0-2.188-2.155v-.505a.6.6,0,1,0-1.2,0v.505a2.373,2.373,0,0,0-2.188,2.155,2.372,2.372,0,0,0,2.188,2.154Zm1.2,0V34.963c.594.157.987.537.987.927S17.713,36.66,17.119,36.818Zm-1.2-5.064v1.855c-.594-.157-.987-.537-.987-.927S15.324,31.912,15.918,31.754Z"
            />
            <path
              className={css(styles.action)}
              d="M28.31,35.114a.679.679,0,0,1,.138-1.35c.091.009.251.029.47.064.361.056.762.131,1.193.229a17.473,17.473,0,0,1,3.621,1.229,9.951,9.951,0,0,1,4.273,3.543,16.787,16.787,0,0,0-1.712-.035,9.4,9.4,0,0,0-3.14-2.281,16.2,16.2,0,0,0-3.341-1.132c-.4-.09-.77-.16-1.1-.212C28.515,35.139,28.378,35.121,28.31,35.114Z"
            />
          </g>
          <path
            className={css(styles.grey)}
            d="M61.227,59.111a5.943,5.943,0,1,1-5.9,5.943A5.925,5.925,0,0,1,61.227,59.111Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M91.633,34.939H65.379c-15.716,0-20.144,22.789-18.964,22.265L36.922,66.24a.585.585,0,0,0,.585.585H72.146c-.015-.193-.029-.388-.029-.586a7.151,7.151,0,1,1,14.3,0c0,.2-.014.393-.03.586h7.937a.585.585,0,0,0,.585-.585V38.218A3.278,3.278,0,0,0,91.633,34.939ZM88.008,52.127a1.861,1.861,0,0,1-1.855,1.855H81.189a1.861,1.861,0,0,1-1.856-1.855V44.584a1.861,1.861,0,0,1,1.856-1.856h4.964a1.861,1.861,0,0,1,1.855,1.856Z"
          />
          <rect className={css(styles.actionAccent)} x="78.747" y="47.71" width="9.884" height="1.172" rx="0.586" />
          <path
            className={css(styles.action)}
            d="M72.984,34.939H48.913a25.205,25.205,0,0,0-25.2,25.205v6.163a.518.518,0,0,0,.518.518H48.3a.518.518,0,0,1-.518-.518V60.144A25.205,25.205,0,0,1,72.984,34.939ZM43.747,54.946h-15a16.48,16.48,0,0,1,5.314-10.707H48.905S44.451,49.241,43.747,54.946Z"
          />
          <rect className={css(styles.actionAccent)} x="29.618" y="48.745" width="16.507" height="1.172" rx="0.586" />
          <path
            className={css(styles.grey)}
            d="M82.194,66.478a2.838,2.838,0,1,0-2.838,2.856A2.848,2.848,0,0,0,82.194,66.478Zm3.3,0A6.143,6.143,0,1,1,79.356,60.3,6.163,6.163,0,0,1,85.5,66.478Z"
          />
          <path
            className={css(styles.action)}
            d="M72.258,66.421c0-.219.013-.436.032-.651H69.665a1.648,1.648,0,0,0,.02-.2V46.419a1.648,1.648,0,0,0-1.644-1.643h-6.62a1.647,1.647,0,0,0-1.643,1.643v19.15a1.648,1.648,0,0,0,.02.2H23.443a.431.431,0,0,0-.431.431v1.131a.431.431,0,0,0,.431.431H72.388A7.142,7.142,0,0,1,72.258,66.421Z"
          />
          <path
            className={css(styles.action)}
            d="M95.3,65.77H86.409c.02.215.033.432.033.651a7.142,7.142,0,0,1-.13,1.342H95.3a.431.431,0,0,0,.431-.431V66.2A.431.431,0,0,0,95.3,65.77Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M34.869,65.684H18.981a.321.321,0,0,0-.321.321v1.4a.321.321,0,0,0,.321.321h8.875v2.678H23.844a.886.886,0,0,0,0,1.771H28.28a1.348,1.348,0,0,0,1.348-1.347v-3.1h5.241a.321.321,0,0,0,.32-.321v-1.4A.321.321,0,0,0,34.869,65.684Z"
          />
          <path
            className={css(styles.grey)}
            d="M24.479,71.358a1.345,1.345,0,1,0-1.345,1.354A1.349,1.349,0,0,0,24.479,71.358Zm1.567,0a2.912,2.912,0,1,1-2.912-2.929A2.921,2.921,0,0,1,26.046,71.358Z"
          />
          <rect className={css(styles.white)} x="61.435" y="46.586" width="6.756" height="7.199" rx="1.41" />
        </g>
      </svg>
    );
  }
}
